import { Directive, HostListener } from '@angular/core';


@Directive({
  selector: '[appOnlyNumbers]',
  standalone: true
})
export class OnlyNumbersDirective {
  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
    const input = event.key;
    const isNumber = /^[0-9]*$/.test(input);
    if (!isNumber) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent): void {
    
    // Not permitted to paste if char or spl char exist:
     // Access the clipboard Paste data
     const pastedText = (event.clipboardData || (window as any).clipboardData).getData('text/plain');
    // Allow pasting if content is empty or consists only of numbers (  Remove non-numeric characters from the pasted text)
    if (!pastedText || /^[\d]+$/.test(pastedText)) {
      return;
    }
    event.preventDefault();

     // It permitted to paste if char or spl char exist; remove the spl char and char and paste only number:
    const onlyNumbers = pastedText.replace(/[^\d]/g, '');
    const inputElement = event.target as HTMLInputElement;
    //Paste only the numbers.
    inputElement.value = onlyNumbers;

  }



}
